// Copyright (c) 2020 Deere & Company

import { applyMiddleware, compose, createStore } from 'redux';
import rootReducer from './root-reducer';
import thunk from 'redux-thunk';

const initialState = {};

const enhancers = [];

const middleware = [thunk];

if ( process.env.NODE_ENV === 'development' ) {

    // eslint-disable-next-line no-underscore-dangle
    const devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;

    if ( typeof devToolsExtension === 'function' ) {

        enhancers.push( devToolsExtension() );

    }

}

const composedEnhancers = compose(
    applyMiddleware( ...middleware ),
    ...enhancers
);

const store = createStore( rootReducer(), initialState, composedEnhancers );

export default store;
